import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { apiAxios } from "../../../../utils/apiAxios";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";

const Priority = () => {
  const [data, setData] = useState<any[]>([]);
  const [priority, setPriority] = useState("");
  const [editId, setEditId] = useState<number | null>(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState<number | null>(null);

  // ================= FETCH =================
const fetchData = async () => {
  try {
    const res = await apiAxios.get(`/TicketPriority/GetAll`);

    // ✅ ResponseDto handle karo
    const items = res.data?.singleData || [];

    const formatted = items
      .map((item: any) => ({
        id: item.id,
        priority: item.name,
        raw: item,
      }))
      .sort((a: any, b: any) => b.id - a.id);

    setData(formatted);
  } catch (err: any) {
    toast.error(err?.response?.data?.status || "Failed to load data");
  }
};

  useEffect(() => {
    fetchData();
  }, []);

  // ================= ADD =================
  const handleAdd = async () => {
    if (!priority.trim()) {
      toast.warning("Please enter priority!");
      return;
    }

    try {
      await apiAxios.post(`/TicketPriority/Create`, {
        name: priority,
        description: "",
      });

      toast.success("Priority added successfully!");
      setPriority("");
      fetchData();
    } catch (err: any) {
      toast.error(err?.response?.data?.status || "Error adding priority");
    }
  };

  // ================= EDIT =================
  const handleEdit = (row: any) => {
    setPriority(row.priority);
    setEditId(row.id);
  };

  // ================= UPDATE =================
  const handleUpdate = async () => {
    if (!priority.trim() || editId === null) {
      toast.warning("Please enter priority!");
      return;
    }

    try {
      await apiAxios.put(`/TicketPriority/Update/${editId}`, {
        id: editId,
        name: priority,
        description: "",
        isActive: true,
      });

      toast.success("Priority updated successfully!");
      setPriority("");
      setEditId(null);
      fetchData();
    } catch (err: any) {
      toast.error(err?.response?.data?.status || "Error updating priority");
    }
  };


  const confirmDelete = (id: number) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  // ================= DELETE =================
  const handleDelete = async () => {
    if (deleteId === null) return;

    try {
      await apiAxios.delete(`/TicketPriority/Delete/${deleteId}`);

      toast.success("Priority deleted successfully!");
      setData(prev => prev.filter(item => item.id !== deleteId));

    } catch (err: any) {
      toast.error(err?.response?.data?.status || "Error deleting priority");
    } finally {
      setShowDeleteModal(false);
      setDeleteId(null);
    }
  };

  // ================= CANCEL =================
  const handleCancel = () => {
    setPriority("");
    setEditId(null);
  };

  // ================= TABLE =================
  const columns = [
    {
      name: "ID",
      selector: (row: any) => row.id,
      center: true,
    },
    {
      name: "Priority",
      selector: (row: any) => row.priority,
      center: true,
      sortable: true,
    },
    {
      name: "Action",
      cell: (row: any) => (
        <div className="d-flex justify-content-center gap-2">
          <button
           className="action-btn edit"
            onClick={() => handleEdit(row)}
          >
            <i className="bi bi-pencil-square"></i>
          </button>

          <button
            className="action-btn delete"
            onClick={() => confirmDelete(row.id)}
          >
            <i className="bi bi-trash"></i>
          </button>
        </div>
      ),
      center: true,
    },
  ];

  return (
    <div>
      <h4 className="mb-4">
        {editId ? "Update Priority" : "Add Priority"}
      </h4>

      {/* INPUT */}
      <div className="premium-card mb-4">
        <div className="row g-3 align-items-end">
          <div className="col-12">
            <label className="form-label">Priority</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter priority"
              value={priority}
              onChange={(e) => setPriority(e.target.value)}
            />
          </div>

          <div className="col-12 col-md-3">
            {editId ? (
              <>
                <button className="btn btn-primary me-2" onClick={handleUpdate}>
                  Update
                </button>

                <button className="btn btn-secondary" onClick={handleCancel}>
                  Cancel
                </button>
              </>
            ) : (
              <button className="btn btn-primary" onClick={handleAdd}>
                Add
              </button>
            )}
          </div>
        </div>
      </div>

      {/* TABLE */}
      <div className="premium-card">
        <h5 className="mb-3">Priority List</h5>

        <DataTable
          columns={columns}
          data={data}
          pagination
          striped
          highlightOnHover
          responsive
        />
      </div>

      {/*  DELETE MODAL */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Body className="text-center">
          Are you sure you want to delete this priority?
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <button className="btn btn-primary" onClick={handleDelete}>
            Yes
          </button>
          <button
            className="btn btn-secondary"
            onClick={() => setShowDeleteModal(false)}
          >
            No
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Priority;